<template>
    <div ref="infoRequestModal" class="dialog full" role="dialog" v-close-dialog="closeInfoRequest">
        <div id="InfoRequest" class="container">
            <button class="close icon fastic-close" :aria-label="localizer.get('App.Common.Close')" @click="closeInfoRequest"></button>
            <div class="inforequest inner">
                <div v-if="!isSuccess" class="request">
                    <fieldset :disabled="isLoadingForm" v-if="events.length !== 0">
                        <h3 class="maintitle s36 mrg" data-mrgb="30">{{ localizer.get("LandingPage.InfoRequest.SelectEvents") }}</h3>
                        <div class="cta mrg" data-mrgb="30">
                            <a :href="routes.LandingPage_LandingPage_Detail" class="button secondary">{{ localizer.get("LandingPage.InfoRequest.GoToEventDetails") }}</a>
                        </div>
                        <div class="item event-option-list">
                            <div class="checkbox event-option">
                                <input aria-label="OnlyExhibition" type="checkbox" id="OnlyExhibition" value="OnlyExhibition" @change="setEvents($event)" v-model="formData.events">
                                <label for="OnlyExhibition">
                                    <template v-if="!isQrCodeScan">
                                        <span class="maintitle">{{ localizer.get("LandingPage.InfoRequest.OnlyExhibition_Title") }}</span>
                                        {{ localizer.get("LandingPage.InfoRequest.OnlyExhibition_Description") }}
                                    </template>
                                    <template v-else>
                                        <span class="maintitle">{{ localizer.get("LandingPage.InfoRequest.OnlyContact_Title") }}</span>
                                        {{ localizer.get("LandingPage.InfoRequest.OnlyContact_Description") }}
                                    </template>
                                </label>
                            </div>
                            <div class="checkbox event-option" v-for="(item, index) in events" :key="index">
                                <input :aria-label="item.date" type="checkbox" :id="item.value" :value="item.value" @change="setEvents($event)" v-model="formData.events">
                                <label :for="item.value">
                                    <span class="maintitle">{{ item.date }}</span>
                                    {{ item.description }}
                                </label>
                            </div>
                        </div>
                    </fieldset>
                    <div v-if="!isLoading" class="formimage">
                        <div class="form" data-request>
                            <fieldset :disabled="isLoadingForm">
                                <h3 v-if="!isQrCodeScan" class="maintitle s60">{{ titleForm }}</h3>
                                <h3 v-else class="maintitle s60">{{ localizer.get("LandingPage.InfoRequest.QRCodeFormTitle") }}</h3>
                                <div class="group">
                                    <div class="item">
                                        <label for="NameSurname">{{ localizer.get("LandingPage.InfoRequest.NameSurname") }}</label>
                                        <input type="text" id="Name" v-model.lazy="formData.name" :placeholder="localizer.get('LandingPage.InfoRequest.NamePlaceholder')" :class="[{ 'input-validation-error': isValidationError('Name') }, 'input w300']">
                                    </div>
                                    <div class="item">
                                        <input type="text" id="Surname" v-model.lazy="formData.surname" :placeholder="localizer.get('LandingPage.InfoRequest.SurnamePlaceholder')" :class="[{ 'input-validation-error': isValidationError('Surname') }, 'input w300']">
                                    </div>
                                </div>
                                <div class="group">
                                    <div class="item">
                                        <label for="Company">{{ localizer.get("LandingPage.InfoRequest.CompanyAndProfession") }}</label>
                                        <input type="text" :aria-label="localizer.get('LandingPage.InfoRequest.Company')" id="Company" :placeholder="localizer.get('LandingPage.InfoRequest.CompanyPlaceholder')" v-model.lazy="formData.company" :class="[{ 'input-validation-error': isValidationError('Company') }, 'input w300']">
                                    </div>
                                    <div class="item">
                                        <select id="Profession" v-model="formData.profession" :class="[{ 'input-validation-error': isValidationError('Profession') }, 'input w300']">
                                            <option :value="null">...</option>
                                            <option v-for="(item, index) in professionalRoles" :value="item.value" :key="index">{{ item.title }}</option>
                                        </select>
                                    </div>
                                    <div class="item">
                                        <label for="Country">{{ localizer.get("LandingPage.InfoRequest.Country") }}</label>
                                        <input type="text" :aria-label="localizer.get('LandingPage.InfoRequest.Country')" id="Country" :placeholder="localizer.get('LandingPage.InfoRequest.CountryPlaceholder')" v-model.lazy="formData.country" :class="[{ 'input-validation-error': isValidationError('Country') }, 'input w300']">
                                    </div>
                                </div>
                                <div class="group">
                                    <div class="item">
                                        <label for="Phone">{{ localizer.get("LandingPage.InfoRequest.PhoneEmail") }}</label>
                                        <input type="tel" :aria-label="localizer.get('LandingPage.InfoRequest.Phone')" id="Phone" :placeholder="localizer.get('LandingPage.InfoRequest.PhonePlaceholder')" v-model.lazy="formData.phone" :class="[{ 'input-validation-error': isValidationError('Phone') }, 'input w300']">
                                    </div>
                                    <div class="item">
                                        <input type="email" :aria-label="localizer.get('LandingPage.InfoRequest.Email')" id="Email" :placeholder="localizer.get('LandingPage.InfoRequest.EmailPlaceholder')" v-model.lazy="formData.email" :class="[{ 'input-validation-error': isValidationError('Email') }, 'input w300']">
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset :disabled="isLoadingForm">
                                <div class="desc small" v-html="localizer.get('LandingPage.LightBuilding.PrivacyPolicy', routes.UrlPrivacyPolicyLightBuilding)"></div>
                                <div class="item">
                                    <div class="checkbox">
                                        <input type="checkbox" name="IsMarketingPolicy" id="IsMarketingPolicy" v-model="formData.isMarketingPolicy">
                                        <label for="IsMarketingPolicy">{{ localizer.get("LandingPage.InfoRequest.PrivacyMarketing") }}</label>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset :disabled="isLoadingForm">
                                <div v-if="validationErrors.length !== 0" class="validation-summary-errors">
                                    <ul>
                                        <li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError.message }}</li>
                                    </ul>
                                </div>
                                <div class="cta">
                                    <button @click="submitForm()" :class="[{ 'loading': isLoadingForm }, 'button']">
                                        <template v-if="!isLoadingForm">{{ localizer.get("LandingPage.InfoRequest.SendRequest") }}</template>
                                    </button>
                                </div>
                            </fieldset>
                            <div class="desc small grecaptcha-terms" v-html="localizer.get('LandingPage.Support.Captcha_Terms')"></div>
                        </div>
                        <img src="/areas/landingpage/images/support-grey.webp" width="620" height="772" alt="Support image" class="support-image">
                    </div>
                </div>
                <div v-else class="request">
                    <div v-if="!isLoading" class="formimage align-items-center">
                        <div class="form">
                            <div class="maintitle s60">{{ localizer.get("LandingPage.InfoRequest.FormSuccessTitleShort") }}</div>
                            <div class="cta s16"><button @click="store.commit('infoRequestStore/setIsDialogVisible', false)" class="button">{{ localizer.get("LandingPage.InfoRequest.Close") }}</button></div>
                        </div>
                        <img src="/areas/landingpage/images/support-grey.webp" width="620" height="772" alt="Support image" class="support-image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

const props = defineProps<{
    recaptchaSiteKey: string;
    titleForm: string;
    landingName: string;
}>();

const store = useStore();
const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(true);
const isLoadingForm = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({
    events: [],
    profession: null,
    isMarketingPolicy: false
});
const events = ref<any[]>([]);
const professionalRoles = ref<any[]>([]);
const validationErrors = ref<any[]>([]);
const isQrCodeScan = ref(false);
const infoRequestModal = ref<HTMLElement | null>(null);

const isDialogVisible = computed(() => store.getters["infoRequestStore/isDialogVisible"]);

watch(isDialogVisible, (newValue) => {
    const url = new URL(window.location.href);
    if (newValue) {
        document.body.classList.add("overflow");
        infoRequestModal.value?.classList.add("show");
    } else {
        document.body.classList.remove("overflow");
        infoRequestModal.value?.classList.remove("show");
    }
    if (newValue) {
        if (!url.searchParams.has("isVisible")) {
            url.searchParams.append("isVisible", "true");
            window.history.pushState(window.history.state, document.title, url.toString());
        }
        return;
    }
    if (url.searchParams.has("isVisible")) {
        url.searchParams.delete("isVisible");
        window.history.pushState(window.history.state, document.title, url.toString());
        formData.value = { events: [], profession: null, isMarketingPolicy: false };
        isSuccess.value = false;
        validationErrors.value = [];
    }
});

onMounted(async () => {
    await getData();
    window.addEventListener("popstate", () => {
        store.commit("infoRequestStore/setIsDialogVisible", (new URL(window.location.href)).searchParams.has("isVisible"));
    });
    const url = new URL(window.location.href);
    if (url.searchParams.has("isVisible")) {
        store.commit("infoRequestStore/setIsDialogVisible", true);
    }
    if (url.searchParams.has("isQrCodeScan")) {
        store.commit("infoRequestStore/setIsDialogVisible", true);
        isQrCodeScan.value = true;
    }
});

async function getData() {
    const response = (await Axios.post(routes.LandingPage_LandingLightBuilding_GetSubscribeData)).data;
    events.value = response.events;
    professionalRoles.value = response.professionalRoles;
    isLoading.value = false;
}

function setEvents(e: any) {
    if (e.target.value === "OnlyExhibition") {
        formData.value.events = formData.value.events.length === 0 ? [events.value[0].value] : ["OnlyExhibition"];
    } else {
        formData.value.events = formData.value.events.length === 0 ? ["OnlyExhibition"] : formData.value.events.filter((x: any) => x !== "OnlyExhibition");
    }
}

async function submitForm() {
    FormHelper.removeFocus();
    validationErrors.value = [];
    isLoadingForm.value = true;
    formData.value.isQrCodeScan = isQrCodeScan.value;
    if (events.value.length === 0) {
        formData.value.events = ["OnlyExhibition"];
    }
    (window as any).grecaptcha.enterprise.ready(async () => {
        const token = await (window as any).grecaptcha.enterprise.execute(props.recaptchaSiteKey, { action: "Submit" });
        try {
            await Axios.post(routes.LandingPage_LandingLightBuilding_Submit, formData.value, { headers: { RecaptchaVerificationToken: token } });
            isSuccess.value = true;
            GTagHelper.sendEvent("form_submit", "landing_info_request", props.landingName);
        } catch (error: any) {
            if (error.response && error.response.status === 400) {
                validationErrors.value = FormHelper.getValidationErrors(error.response.data);
            }
        }
        isLoadingForm.value = false;
    });
}

function closeInfoRequest() {
    store.commit('infoRequestStore/setIsDialogVisible', false);
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}
</script>